const styles = theme => ({
  table: {
    minWidth: '100% !important',
    '& tr td, & tr th': {
      borderBottom: 0
    },
    '& tr:first-child th': {
      borderTop: '1px solid rgba(255, 255, 255, 0.12)'
    },
    '& tr:last-child td': {
      borderBottom: '1px solid rgba(255, 255, 255, 0.12)'
    }
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableHeaderRow: {
    height: 48
  },
  tableCellHeader: {
    color: 'rgba(255,255,255,0.6) !important',
    fontWeight: '400 !important',
    '& span': {
      '&:focus, &:hover': {
        color: 'rgba(255,255,255,0.6) !important'
      }
    }
  },
  tableCell: {
    color: '#FFFFFF !important',
    borderTop: '1px solid rgba(255, 255, 255, 0.12)',
    position: 'relative'
  },
  selectRateRadioButton: {
    padding: '0 !important'
  },
  radioButtonRoot: {
    color: 'rgba(255,255,255,0.6) !important'
  },
  radioButtonChecked: {
    color: 'rgb(255,255,255) !important'
  },
  rowSelected: {
    '& td': {
      borderTop: 0,
      backgroundColor: theme.palette.primary.main
    },
    '& td:first-child': {
      borderRadius: '2px 0 0 0'
    },
    '& td:last-child': {
      borderRadius: '0 2px 0 0'
    }
  },
  tableRowDetailRow: {
    '& td': {
      background: 'transparent',
      padding: '0 !important'
    }
  },
  tooltipButton: {
    padding: 0,
    color: 'rgba(255,255,255,0.6)',
    '&:hover': {
      color: '#FFFFFF'
    },
    position: 'absolute',
    right: 20,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  tooltipButtonShipToday: {
    padding: 0,
    color: 'rgba(255,255,255,0.6)',
    '&:hover': {
      color: '#FFFFFF'
    },
    position: 'absolute',
    right: '50%',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  tooltip: {
    backgroundColor: '#2A3C47',
    color: '#FFFFFF !important',
    maxWidth: 144,
    padding: theme.spacing.unit * 1.5
  },
  tooltipPopper: {
    top: `-${theme.spacing.unit}px !important`
  },
  pagingPanel: {
    padding: 0,
    height: 24,
    marginTop: theme.spacing.unit * 2,
    '& div, & span, & button, & svg': {
      color: 'rgba(255,255,255,0.6)'
    },
    '& > div > span': {
      fontSize: '12px',
      lineHeight: 16,
      letterSpacing: '0.1px',
      paddingRight: theme.spacing.unit * 3
    }
  }
});

export default styles;
